module.exports = __webpack_public_path__ + "media/images/categories/carousel/people-c1e2c1aec5b45b60a6e008074874b815.jpg";